export const CHANGE_SELECTED_CATEGORY = 'CHANGE_SELECTED_CATEGORY'
export const CHANGE_TERMINALID = 'CHANGE_TERMINALID'
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE'
export const CLOSE_MESSAGE = 'CLOSE_MESSAGE'
export const SET_TICKET = 'SET_TICKET'
export const SET_ORDER_TAG_COLORS = 'SET_ORDER_TAG_COLORS'
export const SET_MENU = 'SET_MENU'
export const SET_MENU_ITEMS = 'SET_MENU_ITEMS'
export const LOAD_ENTITY_SCREEN_REQUEST = 'LOAD_ENTITY_SCREEN_REQUEST'
export const LOAD_ENTITY_SCREEN_SUCCESS = 'LOAD_ENTITY_SCREEN_SUCCESS'
export const LOAD_ENTITY_SCREEN_FAILURE = 'LOAD_ENTITY_SCREEN_FAILURE'
export const LOAD_MYTICKETS_REQUEST = 'LOAD_MYTICKETS_REQUEST'
export const LOAD_MYTICKETS_SUCCESS = 'LOAD_MYTICKETS_SUCCESS'
export const LOAD_MYTICKETS_FAILURE = 'LOAD_MYTICKETS_FAILURE'
export const TICKETS_NEEDS_REFRESH = 'TICKETS_NEEDS_REFRESH'
export const TICKETS_REFRESHED = 'TICKETS_REFRESHED'
export const AUTHENTICATION_REQUEST = 'AUTHENTICATION_REQUEST'
export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS'
export const AUTHENTICATION_FAILURE = 'AUTHENTICATION_FAILURE'



// WEBPACK FOOTER //
// ./app/constants/ActionTypes.js